export const PublicPathPlugin = {
    install(Vue, options) {
        Vue.mixin({
            computed: {
                publicPath() {
                    return process.env.BASE_URL;
                }
            }
        });
    }
};
